import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: var(--layer-fullpage-modal);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
`
